// extracted by mini-css-extract-plugin
module.exports = {"container":"TopTabs_container__KX1Yq","underline":"TopTabs_underline__KZM7h"};